import { Grid, Button, Typography, useMediaQuery } from "@material-ui/core"
import "./PackPass.css"
import { CaritraWidgetCalcCurrency, CaritraWidgetJoinParams } from "../../utils"
import LightTooltip from "../LightTooltip/LightTooltip"

const CaritraWidgetPackPass = (props) => {
    const { option, staff, widgetInfo, packpassIndex, redirectURL } = props
    const mobile = useMediaQuery(`(max-width: 37.5rem)`, { noSsr: true })
    const option_data = {
        optionId: option.optionId,
        staffId: staff ? staff.staffId : undefined
    }
    return (
        <Grid container className="CaritraWidgetPackPassContainer">
            <Grid item xs={mobile ? 12 : 4} className="CaritraWidgetPackPassInfoContainer">

                <LightTooltip arrow title={option.name}>
                    <Typography className="CaritraWidgetPackPassTitle" noWrap>
                        {option.name}
                    </Typography>
                </LightTooltip>
                <Typography className="CaritraWidgetPackPassText" noWrap>
                    {option.optionSettings.sessionCount === 1 ?
                        `${option.optionSettings.sessionCount} Session` :
                        `${option.optionSettings.sessionCount} Sessions`}
                </Typography>
                <Typography className="CaritraWidgetPackPassText">
                    {
                        option.type === "Pack" ?
                            `Use within ${option.optionSettings.validity} ${option.optionSettings.validityUnit}`
                            :
                            option.type === "Season Pass" ?
                                `Valid from ${option.optionSettings.startDateStr} to ${option.optionSettings.endDateStr}`
                                : null
                    }
                </Typography>

            </Grid>
            <Grid item xs={mobile ? 12 : 4} className="CaritraWidgetPackPassSectionContainer">
                <div className="CaritraWidgetPackPassPricingContainer CaritraWidgetPackPassApplyMax">
                    <LightTooltip arrow title={CaritraWidgetCalcCurrency(option.price, widgetInfo.currencyInfo)}>
                        <Typography className="CaritraWidgetPackPassPrice" align={mobile ? "left" : "center"} color="primary" noWrap>
                            {CaritraWidgetCalcCurrency(option.price, widgetInfo.currencyInfo)}
                        </Typography>
                    </LightTooltip>
                    {
                        option.discounts && option.discounts.length > 0 ?
                            <Typography align={mobile ? "left" : "center"}>
                                <b>Applicable Discount(s)</b>
                            </Typography>
                            : null
                    }
                    <div className="CaritraWidgetPackPassDiscountContainer">
                        <div className="CaritraWidgetPackPassDiscountName">
                            {option.discounts.map((discount, index) => (
                                <LightTooltip arrow title={discount.name} key={`pack_pass_${packpassIndex}_${staff ? staff.firstName + "_" + staff.lastName : ""}_discount_name_${index}`}>
                                    <Typography noWrap>
                                        {discount.name}
                                    </Typography>
                                </LightTooltip>

                            ))}
                        </div>
                        <div className="CaritraWidgetPackPassDiscountAmount">
                            {option.discounts.map((discount, index) => (
                                <Typography align="right" key={`pack_pass_${packpassIndex}_${staff ? staff.firstName + "_" + staff.lastName : ""}_discount_amount_${index}`} noWrap>
                                    {discount.percentage}%
                                </Typography>))}
                        </div>
                    </div>
                </div>
            </Grid>
            <Grid item xs={mobile ? 12 : 4} className="CaritraWidgetPackPassSectionContainer">
                <div className="CaritraWidgetPackPassButtonContainer">
                    {option.soldOut ?
                        <Button
                            className="CaritraWidgetPackPassButton"
                            variant="contained"
                            color="primary"
                            disabled
                        >
                            <Typography className="CaritraWidgetPackPassButtonText" color="secondary" noWrap>
                                Sold Out
                            </Typography>
                        </Button>

                        :
                        <a href={`${redirectURL}/${widgetInfo.offeringId}?${CaritraWidgetJoinParams(option_data)}`} rel="noopener noreferrer" target="_blank" className="CaritraWidgetPackPassButtonText">
                            <Button
                                className="CaritraWidgetPackPassButton"
                                variant="contained"
                                color="primary"
                                disabled={option.soldOut}
                            >
                                <Typography className="CaritraWidgetPackPassButtonText" color="secondary" noWrap>
                                    Purchase
                                </Typography>
                            </Button>
                        </a>
                    }
                </div>
            </Grid>
        </Grid>
    )
}

export default CaritraWidgetPackPass